import mixins from '#/app/styles';
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native';

const styles = StyleSheet.create({
  paragraph: {
    color: mixins().color.whiteText,
  },
});

export const Paragraph: React.FC<{ children: string; style?: StyleProp<TextStyle> }> = ({
  children,
  style,
}) => {
  return <Text style={[styles.paragraph, style]}>{children}</Text>;
};
